import { VariableDataTypeConfig } from '../../util';
import { VariableValueSimulator } from '../api/variable-value-simulator';
import { AsciiCharacterSimulator } from '../models/ascii-character';
import { RandomValueSimulator } from '../models/random';

export function createDefaultValueSimulator(
  type: VariableDataTypeConfig
): VariableValueSimulator {
  switch (type) {
    case 'UINT32':
      return new RandomValueSimulator({
        min: 0,
        max: Math.pow(2, 32) - 1,
      });
    case 'UINT16':
      return new RandomValueSimulator({
        min: 0,
        max: Math.pow(2, 16) - 1,
      });
    case 'FLOAT32':
      return new RandomValueSimulator({
        min: -Math.pow(2, 31),
        max: Math.pow(2, 31) - 1,
        float: true,
      });
    case 'INT32':
      return new RandomValueSimulator({
        min: -Math.pow(2, 31),
        max: Math.pow(2, 31) - 1,
      });
    case 'INT16':
      return new RandomValueSimulator({
        min: -Math.pow(2, 15),
        max: Math.pow(2, 15) - 1,
      });
    case 'INT8':
      return new RandomValueSimulator({
        min: -Math.pow(2, 7),
        max: Math.pow(2, 7) - 1,
      });
    case 'ASCII':
      return new AsciiCharacterSimulator();
    case 'UINT8':
    default:
      return new RandomValueSimulator({
        min: 0,
        max: Math.pow(2, 8) - 1,
      });
  }
}
